import React from "react";
import CtaPair from "@/components/site/CtaPair";

export default function CtaBanner({ title, sub, healthLabel, showBook = true }) {
  return (
    <section className="bg-brand-navy py-16">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3">{title}</h2>
        {sub && <p className="text-white/75 mb-8">{sub}</p>}
        {showBook ? (
          <CtaPair onDark healthLabel={healthLabel} />
        ) : null}
      </div>
    </section>
  );
}